module.exports = __webpack_public_path__ + "assets/img/select_products7.c6740d2b.svg";